<template>
  <!-- 添加群聊组件 -->
  <div class="p-absolute top-0 right-0 bottom-0 left-0 bg-black-0-2" v-show="visible">
      <div class="p-absolute m-auto top-0 right-0 bottom-0 left-0 p-t-25 r-2 bg-white shadow-5-g-400 z-index-3" style="width: 80%; height: 80%;">
          <p style="position:absolute; top:0; left:0; padding-top:5px; padding-left:10px; width:100%; text-align:left; color:#653EB3; font-size:14px;">转让群主</p>
          <i class="el-icon-circle-close y-fc-999 p-absolute top-5 right-10 f-s-20 cursor-pointer" @click="close"></i>
          <div class="p-relative f-left h-100-p bg-white b-r b-c-150" style="padding-top: 51px; width:300px">
              <div class="p-absolute w-100-p top-0 left-0">
                  <div class="d-table p-x-12 w-100-p b-b b-c-g-100" style="height: 51px;">
                      <div class="d-table-cell v-a-middle">
                          <label class="p-relative d-block h-30 bg-g-100" style="border-radius: 15px;" ref="labelRef">
                              <input class="form-element b-w-0 p-x-20 w-100-p h-30 l-h-30 bg-transparent" type="text" placeholder="搜索" v-model="value"  ref="inputRef">
                              <i class="el-icon-close f-s-18 l-h-30 p-absolute top-0 bottom-0 right-0 m-auto p-x-10 cursor-pointer" @click.prevent="clearValue" v-show="value"></i>
                          </label>
                      </div>
                  </div>
              </div>
              <ul class="h-100-p o-auto left-personnel-box">
                <li class="d-table w-100-p  b-b b-c-g-100 cursor-default bg-g-50-hover" v-for="item in typeData" :key="item.account" @click="checkTurnTeamOwner(item)">
                <div v-if="!value||(value&&((item.nick&&item.nick.includes(value))||(item.tel&&item.tel.includes(value))))" class="p-relative p-l-26 d-table w-100-p h-67 b-b b-c-g-100 cursor-default bg-g-50-hover">
                  <img v-if="item.checked" src="@/assets/images/im/icon_selected@2x.png" style="width: 20px; height: 20px;position: absolute;    top: 50%;left: 18px;transform: translate(-50%,-50%);">
                  <img v-else src="@/assets/images/im/icon_unselected@2x.png" style="width: 20px; height: 20px;position: absolute;top: 50%;left: 18px;transform: translate(-50%,-50%);">
                  <div class="d-table-cell v-a-middle h-100-p w-64" style="text-align: center;">
                    <span v-if="item.account.length==32" class="d-block m-auto w-40 h-40 l-h-40 t-a-center c-white rounded user-select-none" style="background-color: #653EB3;">{{getShortNickname(item.nick||item.tel)}}</span>
                    <img v-else src="@/assets/images/im/kefu.svg" style="width:40px;height:40px;"/>
                  </div>
                  <div class="d-table-cell v-a-middle h-100-p">
                    <div :style="{width:listWidth+'px'}">
                      <p class="t-ellipsis l-h-1-6-em m-r-10">{{item.nick}}</p>
                      <p class="t-ellipsis l-h-1-6-em m-r-10 f-s-12 c-g-500">{{item.tel}}</p>
                      <p class="t-ellipsis l-h-1-6-em m-r-10 f-s-12 c-g-500" v-if="!item.nick&&!item.tel">{{item.account}}</p>
                    </div>
                  </div>
                  </div>
                </li>
              </ul>
          </div>
          <div class="h-100-p o-auto">
              <div class="p-relative p-x-15 p-t-25 h-100-p" style="padding-bottom:120px;">
                  <p class="p-absolute top-0 left-0 p-l-15 w-100-p f-s-14">已选择成员 <span class="c-blue">{{checkData.nick?1:0}}</span>/1</p>
                  <div class="h-100-p o-auto" v-if="checkData.account">
                    <div class="p-relative p-l-26 d-table w-100-p h-67 b-b b-c-g-100 cursor-default bg-g-50-hover">
                      <div class="d-table-cell v-a-middle h-100-p w-64" style="text-align: center;">
                        <span v-if="checkData.account.length==32" class="d-block m-auto w-40 h-40 l-h-40 t-a-center c-white rounded user-select-none" style="background-color: #653EB3;">{{getShortNickname(checkData.nick||checkData.tel)}}</span>
                        <img v-else src="@/assets/images/im/kefu.svg" style="width:40px;height:40px;"/>
                      </div>
                      <div class="d-table-cell v-a-middle h-100-p">
                        <div :style="{width:listWidth+'px'}">
                          <p class="t-ellipsis l-h-1-6-em m-r-10">{{checkData.nick}}</p>
                          <p class="t-ellipsis l-h-1-6-em m-r-10 f-s-12 c-g-500">{{checkData.tel}}</p>
                          <p class="t-ellipsis l-h-1-6-em m-r-10 f-s-12 c-g-500" v-if="!checkData.nick&&!checkData.tel">{{checkData.account}}</p>
                        </div>
                      </div>
                      <i class="el-icon-close y-fc-999 h-30 f-s-18 p-absolute top-0 bottom-0 right-0 m-auto p-x-10 cursor-pointer" @click="deleteTeamOwner(checkData)"></i>
                    </div>
                  </div>
                  <div class="p-absolute bottom-0 left-0 w-100-p p-x-20" style="height:60px;">
                      <div class="t-a-right p-t-10">
                          <button type="button" class="button m-r-10" @click="close">取消</button>
                          <button type="button" class="button button-blue" :disabled="disabledCp" @click="turnTeamOwner">确定</button>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    userInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    im: {
      type: Object,
      default: function () {
        return {};
      }
    },
    teamCurrentList: {
      type: Array,
      default: function () {
        return [];
      }
    },
    width: {
      type: Number,
      default: 185
    }
  },
  data: function () {
    return {
      forwordTeamList:[],
      leaveMessage:'',
      typeData:[],
      visible: false,
      value: '',
      items: [],
      groupName: '',
      privateTeamId: null,
      kecontactItems: [],
      contactLoading: false,
      imLoading: false,
      imAsideLeft:250,
      toGroupVisible:true,
      togroup: 0,
      listWidth: 185,
      checkData:{},
      team:{},
    };
  },
  methods: {
    // 截取名称后俩位
    getShortNickname: function (name) {
      name = name || '';
      var len = name.length;
      return name.slice(len - 2, len);
    },
    deleteTeamOwner(){
      this.checkData = {};
      this.typeData.forEach(val=>{
        this.$set(val,'checked',false);
      })
    },
    turnTeamOwner(){
      let that =this;
      if(this.checkData.account){
        this.$emit('imAlert', {
          message: '您确认要将群主转让吗？',
          type: 'confirm',
          done: function () {
            that.im.transferTeam({
              teamId:that.toAccount,
              account:that.checkData.account,
              leave: false,
              done:function (error, obj){
                that.close();
                if(error){
                  that.$emit('trunTeamOwnerErr',error);
                } else{
                  that.$emit('trunTeamOwnerSuccess','转让群主成功');
                }
              }
            })
          }
        })
      }
    },
    checkTurnTeamOwner(item){
     this.typeData.forEach(val=>{
      this.$set(val,'checked',false);
       if(item.account === val.account){
         if(val.checked){
          this.$set(val,'checked',false);
         }else{
          this.$set(val,'checked',true);
         } 
       }
       if(val.checked){
          this.checkData = val;
       }
     })
     this.bus.$emit("selectNewsTab");
    },
    // 获取本地会话列表(联系人列表)
    getLocalSessions: function () {
      var that = this;
      // console.log('getLocalSessions');
      this.im.getLocalSessions({
        done: function (err, data) {
          if(data&&data.sessions&&data.sessions.length){
            that.$parent.onsessions(data.sessions);
            data.sessions.forEach(item=>{
             
            })
          }
        }
      });
    },
    onFocusEventto: function () {
     
    },
    searchCustomerInfos: function (item) {
      // console.log("111",item);
      var $this = this;
      $this.toGroupVisible = false;
      $this.contactLoading = true;
      $this.kecontactItems = [];
      axiosHttpIm.post('/webIM/searchCustomerInfo', {kcode: item.kCode}).then(
        function (response) {
          if (response.success && response.data) {
            $this.$nextTick(function () {
              this.contactLoading = false;
              this.kecontactItems = response.data.contactList;
            });
          } else if (!response.success) {
            // 这里说明请求k码的接口调用失败
          }
        },
        function () {
          $this.contactLoading = false;
        }
      );
    },

    // 打开、关闭组件
    open: function (val) {
      console.log(val,'open');
      let toAccount = val.toAccount;
      try {
        this.toAccount = toAccount.split("-")[1];
      } catch (error) {
        
      }
      let teampData = val.data || [];
      let owner =val.owner||'';
      teampData = teampData.slice(1);
      teampData = teampData.filter(meber=>{
        // 转让的对象不能是群主或者小圆机器人
        return meber.account != owner && !meber.account.includes('robot');
      })
      this.typeData = teampData;
      console.log('this.typeData',this.typeData);
      if (this.visible) return;
      this.visible = true;
      // 同时关闭群配置页面
      this.bus.$emit('fromTeamTurnToCloseTeamConfig')
      // this.crearePrivateTeam();
    },
    close: function () {
      this.visible = false;
      // 重置选择组件
      this.value = '';
      this.groupName = '';
      this.checkData = {};
    },
    // 清空表单值
    clearValue: function () {
      this.value = '';
    }
  },
  watch: {
    width: function (val) {
      this.listWidth = val - 65;
    }
  },
  computed: {
    disabledCp: function () {
      /* var flag = false;
      this.items.forEach(function (element) {
          if (!element.registerStatus) {
              flag = true;
              return;
          }
      })
      var strlen = 0;
      for (var i = 0; i < this.groupName.length; i++) {
          if (this.groupName.charCodeAt(i) > 255)
              strlen += 2;
          else
              strlen++;
      }
      return !this.groupName || strlen > 30 || flag || this.items.length === 0 || this.items.length > this.teamlevel - 1; */
      return !this.checkData.account;
    }
  }
}
</script>
